export const checkIsDemoAccount = customerId => {
  if (!customerId) return false;

  return ["94", "405", "41206"].some(id => id == customerId);
};
